/**
 * Created by Administrador on 28/07/2016.
 */

(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('itineraryConnectionsController', itineraryConnectionsController)
        .controller('newItineraryConnectionController', newItineraryConnectionController)
        .controller('editItineraryConnectionController', editItineraryConnectionController)
        .controller('deleteItineraryConnectionController', deleteItineraryConnectionController);

    itineraryConnectionsController.$inject = ['linkService','$stateParams','itineraryConnections'];
    newItineraryConnectionController.$inject = ['linkService','itineraryConnectionService','dialogService','$stateParams','groupParameter','$timeout'];
    editItineraryConnectionController.$inject = ['linkService','itineraryConnectionService','$stateParams','itineraryConnections'];
    deleteItineraryConnectionController.$inject = ['itineraryConnectionService', '$uibModalInstance', '$stateParams']

    function itineraryConnectionsController(linkService,$stateParams,itineraryConnections){
        var vm = this;
        vm.linkService = linkService;
        //vm.itineraryConnections = itineraryConnections;
        vm.itineraryConnections = (itineraryConnections.data._embedded) ? itineraryConnections.data._embedded.connectionsItinerary : [];
        vm.itineraryId = $stateParams.id;
        vm.pages = itineraryConnections.data.page;
    }

    function newItineraryConnectionController(linkService,itineraryConnectionService,dialogService,$stateParams,groupParameter,$timeout){
        var vm = this;
        vm.itineraryId = $stateParams.id;
        vm.itineraryConnections = [];
        vm.new = true;
        vm.itineraryConnection = {
            'originId': "",
            'destinyId': "",
            'minimumStay': getParameter('TMIE'),
            'maximumStay': getParameter('TMAE'),
            'maximumStops': getParameter('NPC'),
            'connections': [],
            'checkDay':[]
        };

        vm.generateConnection = function(isValid,itineraryConnection){
            if(isValid){
                if(itineraryConnection.originId == "" || itineraryConnection.originId == undefined ) {
                    dialogService.dialogRequiredError('air.itineraryConnection.origin');
                    vm.itineraryConnection.origin = "";
                }else if(itineraryConnection.destinyId == "" || itineraryConnection.destinyId == undefined) {
                    dialogService.dialogRequiredError('air.itineraryConnection.destiny');
                    vm.itineraryConnection.destiny = "";
                }else {
                    itineraryConnectionService.generatePreviewConnection(vm.itineraryId, itineraryConnection.originId
                        , itineraryConnection.destinyId, itineraryConnection.minimumStay, itineraryConnection.maximumStay
                        , itineraryConnection.maximumStops)
                        .then(function (res) {
                            vm.itineraryConnections = res;
                        });
                }
            }else{
                if(itineraryConnection.originId == "" || itineraryConnection.originId == undefined ) {
                    dialogService.dialogRequiredError('air.itineraryConnection.origin');
                    vm.itineraryConnection.origin = "";
                }else {
                    if (itineraryConnection.destinyId == "" || itineraryConnection.destinyId == undefined) {
                        dialogService.dialogRequiredError('air.itineraryConnection.destiny');
                        vm.itineraryConnection.destiny = "";
                    } else {
                        if (itineraryConnection.minimumStay == "" || itineraryConnection.minimumStay == undefined) {
                            dialogService.dialogRequiredError('air.itineraryConnection.minimumStay');
                        } else {
                            if (itineraryConnection.maximumStay == "" || itineraryConnection.maximumStay == undefined) {
                                dialogService.dialogRequiredError('air.itineraryConnection.maximumStay');
                            } else {
                                if (itineraryConnection.maximumStops == "" || itineraryConnection.maximumStops == undefined) {
                                    dialogService.dialogRequiredError('air.itineraryConnection.maximumStops');
                                }
                            }
                        }
                    }
                }
            }
        }

        vm.addRemoveConnectionDay = function(departuresItineraries, index, indexY,ngModelCheck) {
            $timeout(function() {
                var posConnection = indexOfConnection(index);
                if (ngModelCheck == undefined || ngModelCheck) {
                    if (posConnection == -1) {
                        var connection = {
                            'group': "" + index,
                            'checkDay': [],
                            'departureItineraries': []
                        };
                        vm.itineraryConnection.connections.push(connection);
                        posConnection = vm.itineraryConnection.connections.length - 1;
                    }

                    //insertar departures
                    var j = 1;
                    angular.forEach(departuresItineraries, function (departuresItineraryAux) {
                        var departureItinerary = ({
                            'arrivalTime': departuresItineraryAux.arrivalTime,
                            'departureTime': departuresItineraryAux.departureTime,
                            'order': j,
                            'departureItineraryId': departuresItineraryAux.departureItineraryId,
                            'group': "" + indexY
                        });
                        vm.itineraryConnection.connections[posConnection].departureItineraries.push(departureItinerary);
                        j++
                    });
                } else {
                    var posDepartureItinerary = indexOfDepartureItinerary(posConnection, indexY);
                    vm.itineraryConnection.connections[posConnection].departureItineraries.splice(posDepartureItinerary, departuresItineraries.length);
                    if (vm.itineraryConnection.connections[posConnection].departureItineraries.length == 0)
                        vm.itineraryConnection.connections.splice(posConnection, 1);
                }
            },100);
        }

        function indexOfConnection(indexX){//devolvera la posicion
            var pos = -1;
            for(var i=0; i<vm.itineraryConnection.connections.length; i++){
                if(vm.itineraryConnection.connections[i].group == indexX){
                    pos = i;
                    break;
                }
            }
            return pos;
        }

        function indexOfDepartureItinerary(posConnection,indexY){//devolvera la posicion
            var pos = -1;
            for(var i=0; i<vm.itineraryConnection.connections[posConnection].departureItineraries.length; i++){
                if(vm.itineraryConnection.connections[posConnection].departureItineraries[i].group == indexY){
                    pos = i;
                    break;
                }
            }
            return pos;
        }

        vm.deleteConnectionList = function(){
            vm.itineraryConnection.connections = [];
            vm.itineraryConnection.checkDay = [];
            vm.itineraryConnections = [];
        }

        vm.saveConnectionItinerary = function(itineraryConnection){
            itineraryConnectionService.saveItineraryConnection(vm.itineraryConnection)
                .then(function(){
                    linkService.reloadRoute('itineraryConnections', {id : vm.itineraryId});
                });
        }

        function getParameter(code){
            var res = 0;
            var parameters = (groupParameter.data._embedded) ? groupParameter.data._embedded.parameters : [];
            for(var i=0; i<parameters.length; i++) {
                var parameter = parameters[i];
                if (parameter.code == code) {
                    res = parseInt(parameter.value);
                    break;
                }
            }
            return res;
        }
    }

    function editItineraryConnectionController(linkService,itineraryConnectionService,$stateParams,itineraryConnections){
        var vm = this;
        vm.itineraryId = $stateParams.id;
        vm.connectionItineraryId = $stateParams.itineraryConnectionId;
        vm.length = 0;

        vm.itineraryConnection = {
            'origin': itineraryConnections._embedded.airports[0].iata,
            'destiny': itineraryConnections._embedded.airports[1].iata,
            'originId': itineraryConnections._embedded.segment.originAirportId,
            'destinyId': itineraryConnections._embedded.segment.destinyAirportId,
            'minimumStay': itineraryConnections.minimunStay,
            'maximumStay': itineraryConnections.maximunStay,
            'maximumStops': itineraryConnections.maximunStop,
            'connections': [],
            'checkDay': [{}]
        };

        vm.itineraryConnections = [];
        vm.itineraryConnections.push(itineraryConnections._embeddeds.generationConnection);
        addConnectionChecked();
        vm.buttonSave = true;
        vm.oldCheck =  angular.copy(vm.itineraryConnection.checkDay);

        vm.addRemoveConnectionDay = function(departuresItineraries, index, indexY,ngModelCheck) {
            var posConnection = indexOfConnection(index);
            if (ngModelCheck) {
                if (posConnection == -1) {
                    var connection = {
                        'group': "" + index,
                        'checkDay': [],
                        'departureItineraries': []
                    };
                    vm.itineraryConnection.connections.push(connection);
                    posConnection = vm.itineraryConnection.connections.length - 1;
                }

                var j = 1;
                angular.forEach(departuresItineraries, function (departuresItineraryAux) {
                    var departureItinerary = ({
                        'arrivalTime': departuresItineraryAux.arrivalTime,
                        'departureTime': departuresItineraryAux.departureTime,
                        'order': j,
                        'departureItineraryId': departuresItineraryAux.departureItineraryId,
                        'group' : ""+indexY
                    });
                    vm.itineraryConnection.connections[posConnection].departureItineraries.push(departureItinerary);
                    j++
                });
            }else{
                var posDepartureItinerary = indexOfDepartureItinerary(posConnection,indexY);
                vm.itineraryConnection.connections[posConnection].departureItineraries.splice(posDepartureItinerary, departuresItineraries.length);
                if(vm.itineraryConnection.connections[posConnection].departureItineraries.length == 0)
                    vm.itineraryConnection.connections.splice(posConnection , 1);
            }
            vm.change();
        }

        function indexOfConnection(indexX){//devolvera la posicion
            var pos = -1;
            for(var i=0; i<vm.itineraryConnection.connections.length; i++){
                if(vm.itineraryConnection.connections[i].group == indexX){
                    pos = i;
                    break;
                }
            }
            return pos;
        }

        function indexOfDepartureItinerary(posConnection,indexY){//devolvera la posicion
            var pos = -1;
            for(var i=0; i<vm.itineraryConnection.connections[posConnection].departureItineraries.length; i++){
                if(vm.itineraryConnection.connections[posConnection].departureItineraries[i].group == indexY){
                    pos = i;
                    break;
                }
            }
            return pos;
        }

        function addConnectionChecked(){
            vm.length = itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList.length;
            for(var i=0; i<itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList.length; i++) {
                vm.itineraryConnection.checkDay[0][i] = itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList[i].departureItineraries[0].check;
                if(itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList[i].departureItineraries[0].check) {
                    if(vm.itineraryConnection.connections.length==0) {
                        var connection = {
                            'group': 0,
                            'checkDay': [],
                            'departureItineraries': []
                        };
                        vm.itineraryConnection.connections.push(connection);
                    }

                    for(var j=0; j<itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList[i].departureItineraries.length; j++){
                        var departureItinerary = ({
                            'arrivalTime': itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList[i].departureItineraries[j].arrivalTime,
                            'departureTime': itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList[i].departureItineraries[j].departureTime,
                            'order': (j+1),
                            'departureItineraryId': itineraryConnections._embeddeds.generationConnection.departureItineraryConnectionList[i].departureItineraries[j].departureItineraryId,
                            'group' : ""+i
                        });

                        vm.itineraryConnection.connections[0].departureItineraries.push(departureItinerary);
                    }
                }
            }
        }

        vm.saveConnectionItinerary = function(isValid){
            itineraryConnectionService.updateItineraryConnection(vm.connectionItineraryId,vm.itineraryConnection)
                .then(function(){
                    linkService.reloadRoute('itineraryConnections', {id: vm.itineraryId});
                });
        }

        vm.change = function(){
            vm.buttonSave = true;
            for(var i=0; i<vm.length; i++){
                if(vm.itineraryConnection.checkDay[0][i]!=vm.oldCheck[0][i]){
                    vm.buttonSave = false;
                    break;
                }
            }
        }
    }

    function deleteItineraryConnectionController(itineraryConnectionService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.connectionItineraryId = $stateParams.itineraryConnectionId;
        vm.deleteItineraryConnection = function(){
            itineraryConnectionService.deleteConnectionItinerary(vm.connectionItineraryId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
